import React from 'react'
import Modal from 'react-bootstrap/Modal'
import { Button } from 'react-bootstrap'
import './ModalArriveClientReserv.scss'
import { cancelReservation, arrivedReservation } from '../../../../../../../../../crud/clients_api/client_reservations';

interface ModalArriveClientReservProps {
  show: boolean;
  onClose: () => void;
  reservationId: number;
  mesa_id?: number;
  onArrived: () => void;
  onCancelled: () => void;
  setSalones?: React.Dispatch<React.SetStateAction<any[]>>;
}

const ModalArriveClientReserv: React.FC<ModalArriveClientReservProps> = ({ show, onClose, reservationId, onArrived, onCancelled, setSalones, mesa_id }) => {
  // Cambia el estado de la mesa usando setSalones y mesa_id recibido por props
  const updateMesaState = (mesaId: number, newState: boolean) => {
    if (!setSalones) return;
    setSalones((prevSalones) => prevSalones.map((salon: any) => ({
      ...salon,
      mesas: salon.mesas.map((mesa: any) =>
        Number(mesa.id) === mesaId ? { ...mesa, state: newState } : mesa
      )
    })));
  };

  const handleArrived = async () => {
    await arrivedReservation(reservationId);
    if (typeof mesa_id === 'number') updateMesaState(mesa_id, true); // Bloquear mesa al llegar
    onArrived();
    onClose();
  };

  const handleCancel = async () => {
    await cancelReservation(reservationId);
    if (typeof mesa_id === 'number') updateMesaState(mesa_id, false); // Liberar mesa al cancelar
    onCancelled();
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose} centered className="modal-arrive-client">
      <Modal.Header>
        <div className="form-modal-title-container">
          <h2 className="form-modal-title">¿El cliente llegó a la reserva?</h2>
        </div>
        <button 
          className="modal-close-button"
          onClick={onClose}
          aria-label="Cerrar"
        >
          ×
        </button>
      </Modal.Header>
      <Modal.Body>
        <p style={{ fontSize: '0.9375rem', color: 'var(--text-color)', margin: 0 }}>
          ¿Deseas marcar la reserva como llegada o cancelarla?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <div className="form-modal-footer-custom">
          <Button variant="none" className='form-button-cancel' onClick={handleCancel}>
            No, cancelar la reserva
          </Button>
          <Button variant="none" className='form-button-create' onClick={handleArrived}>
            Sí, llegó a la reserva
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalArriveClientReserv